import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ItemIconsList extends Component {
  static propTypes = {
    listData: PropTypes.array.isRequired,
    selectedItemId: PropTypes.number,
    chooseItemHandler: PropTypes.func.isRequired,
    iconSource: PropTypes.object,
    iconSourceFieldName: PropTypes.string,
    labelFieldName: PropTypes.string.isRequired
  };

  render () {
    const { listData, selectedItemId, chooseItemHandler, iconSource, iconSourceFieldName, labelFieldName } = this.props;
    return (
      <div className='item-icons-list-wrapper'>
        { listData.map(listItem => (
          <div
            key={listItem.id}
            className={`item-icons-wrapper ${listItem.id === selectedItemId ? 'selected' : ''}`}
            onClick={() => chooseItemHandler(listItem)}
          >
            <div
              className='item-icon'
              style={{ backgroundImage: `url('${(iconSource && iconSource[listItem.id]) || listItem[iconSourceFieldName]}')` }}
            />
            <p className='item-label'>{listItem[labelFieldName] || listItem[labelFieldName]}</p>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/ItemIconsList.js